<template>
  <VModal
    ref="modal"
    modal-classes="max-w-md mx-auto"
    disable-backdrop-click
    @modal:hidden="$emit('closed')"
  >
    <div class="rounded shadow-xs w-full max-w-2xl mx-auto" @click.stop>
      <div class="rounded shadow-lg bg-white overflow-hidden divide-y divide-gray-200">
        <div class="h-10 bg-white pl-4">
          <div class="flex items-center justify-between">
            <div class="flex-1">
              <h1 class="text-sm">Select Asset</h1>
            </div>
            <div class="flex-none">
              <button
                class="h-10 w-10 inline-flex items-center justify-center hover:bg-gray-200 focus:outline-none"
                @click="$refs.modal.close()"
              >
                <svg viewBox="0 0 24 24" fill="currentColor" class="inline-flex w-5 h-5">
                  <path
                    d="M12 10.586l4.95-4.95 1.414 1.414-4.95
                    4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95
                    4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05
                    5.636z"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
        <div class="p-10 space-y-8">
          <div>
            <label
              class="inline-block px-2 py-1 text-xs leading-5 transition-colors duration-150 uppercase font-medium rounded-l"
              :class="[scope === 'own' ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-900']"
            >
              <input type="radio" value="own" v-model="scope" class="appearance-none" />
              Own
            </label>
            <label
              class="inline-block px-2 py-1 text-xs leading-5 transition-colors duration-150 uppercase font-medium rounded-r"
              :class="[scope === 'client' ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-900']"
            >
              <input type="radio" value="client" v-model="scope" class="appearance-none" />
              Client
            </label>
          </div>
          <AccountAssets
            v-if="scope === 'client'"
            key="clientAssets"
            :account-id="clientId"
            :order-item-id="orderItemId"
            @created="$emit('created', $event)"
          />
          <AccountAssets
            v-if="scope === 'own'"
            key="ownAssets"
            :account-id="accountId"
            :filter="{
              account_relation_id: this.clientId,
            }"
            :order-item-id="orderItemId"
            @created="$emit('created', $event)"
          />
        </div>
      </div>
    </div>
  </VModal>
</template>

<script>
import AccountAssets from './orderItemAttachmentAssetCreateModal/AccountAssetList.vue';

export default {
  name: 'OrderItemAtachmentAssetCreateModal',
  components: {
    AccountAssets,
  },
  props: {
    accountId: {
      type: String,
      required: true,
    },
    clientId: {
      type: String,
      required: true,
    },
    orderItemId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      scope: 'own',
    };
  },
  methods: {
    //
  },
};
</script>
